var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "VueModal",
    {
      attrs: {
        "modal-class": "modal modal-lg",
        title: "Edit Profile: Intro Block",
      },
      model: {
        value: _vm.modalOpen,
        callback: function ($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen",
      },
    },
    [
      _c("form", [
        _c(
          "div",
          { staticClass: "mb-6" },
          [
            _c("label", { ref: "image", attrs: { for: "dropzone" } }, [
              _vm._v("\n        Profile Photo\n        "),
              _c("span", { staticClass: "mb-5 text-sm font-sans-book block" }, [
                _vm._v(
                  "\n        Please upload a horizontal/landscape image (JPEG or PNG), ideally 400 pixels x 300 pixels. This should represent you or your organization. If you are an individual representing the entire organization, you may use a photo of your face. Be sure to click Update at the bottom of the page once you have uploaded your photo.\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "vue-dropzone",
              {
                ref: "image",
                attrs: {
                  id: "dropzone",
                  options: _vm.dropzoneOptions,
                  useCustomSlot: true,
                },
                on: {
                  "vdropzone-success": _vm.uploaded,
                  "vdropzone-error": _vm.updateImageErrorMessage,
                  "vdropzone-removed-file": _vm.resetImage,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "after-drop-message text-n-gray-dark" },
                  [
                    _c("img", {
                      staticClass: "mb-3",
                      attrs: {
                        src: _vm.imgSrc,
                        width: "175",
                        alt: "Placeholder image",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "You may drag-and-drop an image here. File size must be less than 4 MB."
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.imageError
              ? _c("span", { staticClass: "text-lg error text-error-red" }, [
                  _vm._v("\n        " + _vm._s(_vm.imageError) + "\n      "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { attrs: { for: "name" } }, [
            _vm.organization.type === "organization" ? _c("span") : _vm._e(),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.organization.type === "individual"
                    ? "Public"
                    : "Organization"
                ) +
                " Name\n      "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.name,
                expression: "form.name",
              },
            ],
            attrs: { id: "name", type: "text", name: "name" },
            domProps: { value: _vm.form.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "name", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", [
            _vm._v(
              "\n        What country " +
                _vm._s(
                  _vm.organization.type === "individual"
                    ? "are you"
                    : "is your organization"
                ) +
                " located in? "
            ),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.country,
                  expression: "form.country",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              attrs: { name: "country" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.form,
                    "country",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v(" -- please select -- ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.options.countries, function (country) {
                return _c(
                  "option",
                  { key: country.code, domProps: { value: country.code } },
                  [_vm._v("\n          " + _vm._s(country.name) + "\n        ")]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("country"),
                  expression: "errors.has('country')",
                },
              ],
              staticClass: "error-message",
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.errors.first("country")) + "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col md:flex-row mb-12" },
          [
            _c(
              "div",
              {
                class: [_vm.isFromUnitedStates ? "w-full md:w-1/2" : "w-full"],
              },
              [
                _c("label", [
                  _vm._v("\n          City "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.city,
                      expression: "form.city",
                    },
                  ],
                  attrs: { name: "city", type: "text" },
                  domProps: { value: _vm.form.city },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "city", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("city"),
                        expression: "errors.has('city')",
                      },
                    ],
                    staticClass: "error-message",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errors.first("city")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "spacer block md:hidden" }),
            _vm._v(" "),
            _vm.isFromUnitedStates
              ? [
                  _c("div", { staticClass: "w-full md:w-1/4 pl-0 md:pl-2" }, [
                    _c("label", [
                      _vm._v("\n            State "),
                      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.state,
                            expression: "form.state",
                          },
                        ],
                        attrs: { name: "state" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "state",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("-- select --"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.options.states, function (state) {
                          return _c("option", { key: state.code }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(state.name) +
                                "\n            "
                            ),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("state"),
                            expression: "errors.has('state')",
                          },
                        ],
                        staticClass: "error-message",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errors.first("state")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spacer block md:hidden" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-full md:w-1/4 pl-0 md:pl-2" }, [
                    _c("label", [
                      _vm._v("\n            Zip code "),
                      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.zip_code,
                          expression: "form.zip_code",
                        },
                      ],
                      attrs: { name: "zip_code", type: "text" },
                      domProps: { value: _vm.form.zip_code },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "zip_code", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("zip_code"),
                            expression: "errors.has('zip_code')",
                          },
                        ],
                        staticClass: "error-message",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              (_vm.errors.first("zip_code") || "").replace(
                                "_",
                                " "
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _c("label", { attrs: { for: "instagramUrl" } }, [
              _vm._v("\n        Website\n      "),
            ]),
            _vm._v(" "),
            _c("url-input", {
              attrs: { id: "instagramUrl" },
              model: {
                value: _vm.form.website,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "website", $$v)
                },
                expression: "form.website",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-12" }, [
          _c("label", { attrs: { for: "publicEmail" } }, [
            _vm._v("\n        Email\n      "),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.email,
                expression: "form.email",
              },
            ],
            attrs: { id: "publicEmail", type: "text", name: "publicEmail" },
            domProps: { value: _vm.form.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form, "email", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "h2",
          { staticClass: "font-sans text-n-gray-dark font-hairline mb-6" },
          [_vm._v("\n      Social Profiles\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _c("label", { attrs: { for: "facebookUrl" } }, [
              _vm._v("\n        Facebook URL\n      "),
            ]),
            _vm._v(" "),
            _c("url-input", {
              attrs: { id: "facebookUrl" },
              model: {
                value: _vm.form.facebookUrl,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "facebookUrl", $$v)
                },
                expression: "form.facebookUrl",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _c("label", { attrs: { for: "twitterUrl" } }, [
              _vm._v("\n        Twitter URL\n      "),
            ]),
            _vm._v(" "),
            _c("url-input", {
              attrs: { id: "twitterUrl" },
              model: {
                value: _vm.form.twitterUrl,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "twitterUrl", $$v)
                },
                expression: "form.twitterUrl",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _c("label", { attrs: { for: "instagramUrl" } }, [
              _vm._v("\n        Instagram URL\n      "),
            ]),
            _vm._v(" "),
            _c("url-input", {
              attrs: { id: "instagramUrl" },
              model: {
                value: _vm.form.instagramUrl,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "instagramUrl", $$v)
                },
                expression: "form.instagramUrl",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-12" },
          [
            _c("label", { attrs: { for: "linkedinUrl" } }, [
              _vm._v("\n        LinkedIn URL\n      "),
            ]),
            _vm._v(" "),
            _c("url-input", {
              attrs: { id: "linkedinUrl" },
              model: {
                value: _vm.form.linkedinUrl,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "linkedinUrl", $$v)
                },
                expression: "form.linkedinUrl",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-center" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: { click: _vm.update },
            },
            [_vm._v("\n        Update\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-6" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }